import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { GraduationCap } from 'lucide-react';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const Advisors = () => {
  const [advisors, setAdvisors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAdvisors = async () => {
      try {
        setLoading(true);
        const response = await axios.get(`${API}/profiles?type=advisor`);
        setAdvisors(response.data);
        setError(null);
      } catch (err) {
        console.error('Error fetching advisors:', err);
        setError('Failed to load advisors. Please try again later.');
      } finally {
        setLoading(false);
      }
    };
    
    fetchAdvisors();
  }, []);

  if (loading) {
    return (
      <div className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="display-large">College Advisors</h1>
            <p className="body-large">Loading...</p>
          </div>
        </section>
      </div>
    );
  }

  if (error) {
    return (
      <div className="page-content">
        <section className="page-hero">
          <div className="container">
            <h1 className="display-large">College Advisors</h1>
            <p className="body-large error-message">{error}</p>
          </div>
        </section>
      </div>
    );
  }

  return (
    <div className="page-content">
      <section className="page-hero">
        <div className="container">
          <h1 className="display-large">College Advisors</h1>
          <p className="body-large">Expert guidance for your college baseball journey</p>
        </div>
      </section>

      <section className="profiles-section">
        <div className="container">
          {advisors.length === 0 ? (
            <p className="body-large" style={{ textAlign: 'center' }}>Advisor information coming soon.</p>
          ) : (
            <div className="profiles-grid">
              {advisors.map((advisor) => (
                <div key={advisor.id} className="profile-card network-card">
                  <div className="profile-photo">
                    <img src={advisor.photo_url} alt={advisor.name} />
                    <div className="profile-badge">
                      <GraduationCap size={24} />
                    </div>
                  </div>
                  <div className="profile-info">
                    <h3 className="network-card-title">{advisor.name}</h3>
                    <p className="profile-title">{advisor.title}</p>
                    <p className="advisor-college">{advisor.college}</p>
                    <p className="network-card-content">{advisor.bio}</p>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Advisors;